import {useMessageComponents} from '../../../Conversation/MessageComponentContext';
import {AgentCardCompat, AgentCardCompatProps} from './AgentCardCompat';

export function AgentCardComponent({
  conversation,
  agentCall,
  messageId,
}: AgentCardCompatProps) {
  const messageComponentRegistry = useMessageComponents();

  const AgentComponent = messageComponentRegistry['tool-call'];

  if (AgentComponent) {
    const Component = AgentComponent as React.ComponentType<any>;
    return (
      <Component
        agentCall={agentCall}
        conversation={conversation}
        messageId={messageId}
      />
    );
  }

  return (
    <AgentCardCompat
      agentCall={agentCall}
      conversation={conversation}
      messageId={messageId}
    />
  );
}
